import React from 'react';
import * as S from '../ExternalDataTabs.styles';

interface TournamentStatisticsTabProps {
  data: Record<string, any>;
}

export const TournamentStatisticsTab: React.FC<TournamentStatisticsTabProps> = ({ data }) => {
  const stats = data.statistics || {};
  const currentSeason = stats.current_season || {};
  const heroStats = stats.hero_stats || [];
  const roleStats = stats.role_stats || [];

  return (
    <div>
      <S.SectionTitle>Текущий сезон</S.SectionTitle>
      <S.Grid>
        <S.InfoRow>
          <S.InfoLabel>Сезон</S.InfoLabel>
          <S.InfoValue>{currentSeason.season || '—'}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>Матчей сыграно</S.InfoLabel>
          <S.InfoValue>{currentSeason.matches_played || 0}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>Побед</S.InfoLabel>
          <S.InfoValue>{currentSeason.wins || 0}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>Поражений</S.InfoLabel>
          <S.InfoValue>{currentSeason.losses || 0}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>Винрейт</S.InfoLabel>
          <S.InfoValue>{currentSeason.win_rate ? `${currentSeason.win_rate}%` : '—'}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>KDA</S.InfoLabel>
          <S.InfoValue>{currentSeason.kda_ratio || '—'}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>KD</S.InfoLabel>
          <S.InfoValue>{currentSeason.kd_ratio || '—'}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>MVP</S.InfoLabel>
          <S.InfoValue>{currentSeason.mvps || 0}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>SVP</S.InfoLabel>
          <S.InfoValue>{currentSeason.svps || 0}</S.InfoValue>
        </S.InfoRow>
        <S.InfoRow>
          <S.InfoLabel>Время игры (часы)</S.InfoLabel>
          <S.InfoValue>{currentSeason.playtime_hours || '—'}</S.InfoValue>
        </S.InfoRow>
      </S.Grid>

      {roleStats.length > 0 && (
        <>
          <S.SectionTitle>Статистика по ролям</S.SectionTitle>
          {roleStats.map((role: any, index: number) => (
            <S.ListItem key={index}>
              <S.ListItemTitle>
                {role.role_display || role.role}
              </S.ListItemTitle>
              <S.Grid>
                <S.InfoRow>
                  <S.InfoLabel>Матчей</S.InfoLabel>
                  <S.InfoValue>{role.matches_played || 0}</S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>Винрейт</S.InfoLabel>
                  <S.InfoValue>{role.win_rate ? `${role.win_rate}%` : '—'}</S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>KDA</S.InfoLabel>
                  <S.InfoValue>{role.kda_ratio || '—'}</S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>Средние убийства</S.InfoLabel>
                  <S.InfoValue>{role.avg_kills || '—'}</S.InfoValue>
                </S.InfoRow>
              </S.Grid>
            </S.ListItem>
          ))}
        </>
      )}

      {heroStats.length > 0 && (
        <>
          <S.SectionTitle>Статистика по героям</S.SectionTitle>
          {heroStats.slice(0, 5).map((hero: any, index: number) => (
            <S.ListItem key={index}>
              <S.ListItemTitle>{hero.hero_name || 'Неизвестный герой'}</S.ListItemTitle>
              <S.Grid>
                <S.InfoRow>
                  <S.InfoLabel>Матчей</S.InfoLabel>
                  <S.InfoValue>{hero.matches_played || 0}</S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>Винрейт</S.InfoLabel>
                  <S.InfoValue>{hero.win_rate ? `${hero.win_rate}%` : '—'}</S.InfoValue>
                </S.InfoRow>
                <S.InfoRow>
                  <S.InfoLabel>KDA</S.InfoLabel>
                  <S.InfoValue>{hero.kda_ratio || '—'}</S.InfoValue>
                </S.InfoRow>
              </S.Grid>
            </S.ListItem>
          ))}
        </>
      )}
    </div>
  );
};

